// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v4/closing_reasons.proto

/* oxlint-disable */

/** Represents closing reason categories */
export const ApiClosingReasonCategory = {
  /** CLOSING_REASON_CATEGORY_UNSPECIFIED - No closing reason category specified. */
  CLOSING_REASON_CATEGORY_UNSPECIFIED: "CLOSING_REASON_CATEGORY_UNSPECIFIED",
  /**
   * company_closure - Company closure reason.
   */
  company_closure: "company_closure",
  /**
   * price - Price reason.
   */
  price: "price",
  /**
   * service_quality - Service quality reason.
   */
  service_quality: "service_quality",
  /**
   * missing_features - Missing features reason.
   */
  missing_features: "missing_features",
  /**
   * business_not_started - Business not started reason.
   */
  business_not_started: "business_not_started",
} as const;

export type ApiClosingReasonCategory = typeof ApiClosingReasonCategory[keyof typeof ApiClosingReasonCategory];

export namespace ApiClosingReasonCategory {
  export type CLOSING_REASON_CATEGORY_UNSPECIFIED = typeof ApiClosingReasonCategory.CLOSING_REASON_CATEGORY_UNSPECIFIED;
  export type company_closure = typeof ApiClosingReasonCategory.company_closure;
  export type price = typeof ApiClosingReasonCategory.price;
  export type service_quality = typeof ApiClosingReasonCategory.service_quality;
  export type missing_features = typeof ApiClosingReasonCategory.missing_features;
  export type business_not_started = typeof ApiClosingReasonCategory.business_not_started;
}

export function apiClosingReasonCategoryFromJSON(object: any): ApiClosingReasonCategory {
  switch (object) {
    case 0:
    case "CLOSING_REASON_CATEGORY_UNSPECIFIED":
      return ApiClosingReasonCategory.CLOSING_REASON_CATEGORY_UNSPECIFIED;
    case 1:
    case "company_closure":
      return ApiClosingReasonCategory.company_closure;
    case 2:
    case "price":
      return ApiClosingReasonCategory.price;
    case 3:
    case "service_quality":
      return ApiClosingReasonCategory.service_quality;
    case 4:
    case "missing_features":
      return ApiClosingReasonCategory.missing_features;
    case 5:
    case "business_not_started":
      return ApiClosingReasonCategory.business_not_started;
    default:
      return ApiClosingReasonCategory.CLOSING_REASON_CATEGORY_UNSPECIFIED;
  }
}

export function apiClosingReasonCategoryToJSON(object: ApiClosingReasonCategory): string {
  switch (object) {
    case ApiClosingReasonCategory.CLOSING_REASON_CATEGORY_UNSPECIFIED:
      return "CLOSING_REASON_CATEGORY_UNSPECIFIED";
    case ApiClosingReasonCategory.company_closure:
      return "company_closure";
    case ApiClosingReasonCategory.price:
      return "price";
    case ApiClosingReasonCategory.service_quality:
      return "service_quality";
    case ApiClosingReasonCategory.missing_features:
      return "missing_features";
    case ApiClosingReasonCategory.business_not_started:
      return "business_not_started";
    default:
      return "CLOSING_REASON_CATEGORY_UNSPECIFIED";
  }
}

/** Represents closing reason sub-categories */
export const ApiClosingReasonSubCategory = {
  /** CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED - No closing reason sub-category specified. */
  CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED: "CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED",
  /**
   * closed_permanently - Company is permanently closed.
   */
  closed_permanently: "closed_permanently",
  /**
   * temporary_paused_activity - Company activity is temporarily paused.
   */
  temporary_paused_activity: "temporary_paused_activity",
  /**
   * sold_or_transferred - Company is sold or transferred.
   */
  sold_or_transferred: "sold_or_transferred",
  /**
   * other - Other company closure reason.
   */
  other: "other",
  /**
   * subscription_fees - Subscription fee reason
   */
  subscription_fees: "subscription_fees",
  /**
   * extra_fees - Extra fees reason
   */
  extra_fees: "extra_fees",
  /**
   * better_offer_from_competitor - Better offer from competitor reason
   */
  better_offer_from_competitor: "better_offer_from_competitor",
  /**
   * card_related_issues - Card related issues
   */
  card_related_issues: "card_related_issues",
  /**
   * transfer_related_issues - Transfer related issues
   */
  transfer_related_issues: "transfer_related_issues",
  /**
   * app_experience - App experience issues
   */
  app_experience: "app_experience",
  /**
   * support_experience - Support experience issues
   */
  support_experience: "support_experience",
  /**
   * fraud_or_security_issues - Other fraud or security issues
   */
  fraud_or_security_issues: "fraud_or_security_issues",
  /**
   * financing - Missing financing features
   */
  financing: "financing",
  /**
   * payment_collection_methods - Missing payment collection methods
   */
  payment_collection_methods: "payment_collection_methods",
  /**
   * integrations - Missing integrations
   */
  integrations: "integrations",
  /**
   * accounting_features - Missing accounting features
   */
  accounting_features: "accounting_features",
  /**
   * savings_remuneration - Missing savings remuneration features
   */
  savings_remuneration: "savings_remuneration",
  /**
   * capital_deposit_process - Business activity never started.
   */
  capital_deposit_process: "capital_deposit_process",
  /**
   * end_of_promo - End of promotional offer reason. Only for NL organizations.
   */
  end_of_promo: "end_of_promo",
} as const;

export type ApiClosingReasonSubCategory = typeof ApiClosingReasonSubCategory[keyof typeof ApiClosingReasonSubCategory];

export namespace ApiClosingReasonSubCategory {
  export type CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED =
    typeof ApiClosingReasonSubCategory.CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED;
  export type closed_permanently = typeof ApiClosingReasonSubCategory.closed_permanently;
  export type temporary_paused_activity = typeof ApiClosingReasonSubCategory.temporary_paused_activity;
  export type sold_or_transferred = typeof ApiClosingReasonSubCategory.sold_or_transferred;
  export type other = typeof ApiClosingReasonSubCategory.other;
  export type subscription_fees = typeof ApiClosingReasonSubCategory.subscription_fees;
  export type extra_fees = typeof ApiClosingReasonSubCategory.extra_fees;
  export type better_offer_from_competitor = typeof ApiClosingReasonSubCategory.better_offer_from_competitor;
  export type card_related_issues = typeof ApiClosingReasonSubCategory.card_related_issues;
  export type transfer_related_issues = typeof ApiClosingReasonSubCategory.transfer_related_issues;
  export type app_experience = typeof ApiClosingReasonSubCategory.app_experience;
  export type support_experience = typeof ApiClosingReasonSubCategory.support_experience;
  export type fraud_or_security_issues = typeof ApiClosingReasonSubCategory.fraud_or_security_issues;
  export type financing = typeof ApiClosingReasonSubCategory.financing;
  export type payment_collection_methods = typeof ApiClosingReasonSubCategory.payment_collection_methods;
  export type integrations = typeof ApiClosingReasonSubCategory.integrations;
  export type accounting_features = typeof ApiClosingReasonSubCategory.accounting_features;
  export type savings_remuneration = typeof ApiClosingReasonSubCategory.savings_remuneration;
  export type capital_deposit_process = typeof ApiClosingReasonSubCategory.capital_deposit_process;
  export type end_of_promo = typeof ApiClosingReasonSubCategory.end_of_promo;
}

export function apiClosingReasonSubCategoryFromJSON(object: any): ApiClosingReasonSubCategory {
  switch (object) {
    case 0:
    case "CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED":
      return ApiClosingReasonSubCategory.CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED;
    case 1:
    case "closed_permanently":
      return ApiClosingReasonSubCategory.closed_permanently;
    case 2:
    case "temporary_paused_activity":
      return ApiClosingReasonSubCategory.temporary_paused_activity;
    case 3:
    case "sold_or_transferred":
      return ApiClosingReasonSubCategory.sold_or_transferred;
    case 4:
    case "other":
      return ApiClosingReasonSubCategory.other;
    case 5:
    case "subscription_fees":
      return ApiClosingReasonSubCategory.subscription_fees;
    case 6:
    case "extra_fees":
      return ApiClosingReasonSubCategory.extra_fees;
    case 7:
    case "better_offer_from_competitor":
      return ApiClosingReasonSubCategory.better_offer_from_competitor;
    case 8:
    case "card_related_issues":
      return ApiClosingReasonSubCategory.card_related_issues;
    case 9:
    case "transfer_related_issues":
      return ApiClosingReasonSubCategory.transfer_related_issues;
    case 10:
    case "app_experience":
      return ApiClosingReasonSubCategory.app_experience;
    case 11:
    case "support_experience":
      return ApiClosingReasonSubCategory.support_experience;
    case 12:
    case "fraud_or_security_issues":
      return ApiClosingReasonSubCategory.fraud_or_security_issues;
    case 13:
    case "financing":
      return ApiClosingReasonSubCategory.financing;
    case 14:
    case "payment_collection_methods":
      return ApiClosingReasonSubCategory.payment_collection_methods;
    case 15:
    case "integrations":
      return ApiClosingReasonSubCategory.integrations;
    case 16:
    case "accounting_features":
      return ApiClosingReasonSubCategory.accounting_features;
    case 17:
    case "savings_remuneration":
      return ApiClosingReasonSubCategory.savings_remuneration;
    case 18:
    case "capital_deposit_process":
      return ApiClosingReasonSubCategory.capital_deposit_process;
    case 19:
    case "end_of_promo":
      return ApiClosingReasonSubCategory.end_of_promo;
    default:
      return ApiClosingReasonSubCategory.CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED;
  }
}

export function apiClosingReasonSubCategoryToJSON(object: ApiClosingReasonSubCategory): string {
  switch (object) {
    case ApiClosingReasonSubCategory.CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED:
      return "CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED";
    case ApiClosingReasonSubCategory.closed_permanently:
      return "closed_permanently";
    case ApiClosingReasonSubCategory.temporary_paused_activity:
      return "temporary_paused_activity";
    case ApiClosingReasonSubCategory.sold_or_transferred:
      return "sold_or_transferred";
    case ApiClosingReasonSubCategory.other:
      return "other";
    case ApiClosingReasonSubCategory.subscription_fees:
      return "subscription_fees";
    case ApiClosingReasonSubCategory.extra_fees:
      return "extra_fees";
    case ApiClosingReasonSubCategory.better_offer_from_competitor:
      return "better_offer_from_competitor";
    case ApiClosingReasonSubCategory.card_related_issues:
      return "card_related_issues";
    case ApiClosingReasonSubCategory.transfer_related_issues:
      return "transfer_related_issues";
    case ApiClosingReasonSubCategory.app_experience:
      return "app_experience";
    case ApiClosingReasonSubCategory.support_experience:
      return "support_experience";
    case ApiClosingReasonSubCategory.fraud_or_security_issues:
      return "fraud_or_security_issues";
    case ApiClosingReasonSubCategory.financing:
      return "financing";
    case ApiClosingReasonSubCategory.payment_collection_methods:
      return "payment_collection_methods";
    case ApiClosingReasonSubCategory.integrations:
      return "integrations";
    case ApiClosingReasonSubCategory.accounting_features:
      return "accounting_features";
    case ApiClosingReasonSubCategory.savings_remuneration:
      return "savings_remuneration";
    case ApiClosingReasonSubCategory.capital_deposit_process:
      return "capital_deposit_process";
    case ApiClosingReasonSubCategory.end_of_promo:
      return "end_of_promo";
    default:
      return "CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED";
  }
}
